import { createAction, props } from '@ngrx/store';

const actionKey = '[Router history]';

export const SetPrevUrl = createAction(`${actionKey} Set prev url`, props<{ url: string }>());
